// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"3dad6040","801":"60862e73"}[chunkId] + ".chunk.css";
};